import breadcrumbs from './Points_history_breadcrumbs';
import orderby from 'lodash.orderby';
import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
  },
  state: {
    types          : ['recieved', 'spent'],
    sections       : ['study', 'prizes', 'ideas', 'rating'],
    history_items  : [],
    selected_number: 10,
    selected_page  : 1,
    sorting        : 'desc',
    tab            : 0,
  },
  getters: {
    history_items  : ({history_items}) => history_items,
    selected_number: ({selected_number}) => selected_number,
    selected_page  : ({selected_page}) => selected_page,
    tab            : ({tab}) => tab,
    sorting        : ({sorting}) => sorting,
    filtered_by_type({history_items=[]}, {tab}) {
      if (tab==1) {
        return history_items.filter((item)=> item.type == 'received');
      } else if (tab==2) {
        return history_items.filter((item)=> item.type == 'spent');
      } else {
        return history_items;
      }
    },
    paginated({}, {selected_number, filtered_by_type=[], selected_page, sorting}) {
      let asc = orderby(filtered_by_type, (o) => o.date, 'asc');
      let desc = orderby(filtered_by_type, (o) => o.date, 'desc');
      if (sorting == 'asc') {
        return asc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else if (sorting == 'desc') {
        return desc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else {
        return filtered_by_type.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      }
    },
  },
  mutations: {
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SORT_BY_DATE(state, selected) {
      if (selected=='Сначала новые') {
        state.sorting = 'desc';
      } else if (selected=='Сначала старые') {
        state.sorting = 'asc';
      }
    },
    SET_TAB(state, value) {
      state.tab = value;
      state.selected_page = 1;
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SEND_IDEA(state, {idea}) {
      state.ideas.push(idea);
    },
    SET_POINTS_HISTORY(state, points) {
      state.history_items = points.history_items;
    },
  },
  actions: {
    show_number({state, commit, getters}, event) {
      const {filtered_by_type} = getters;
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_type, selected: event});
    },
    sorting_by_date({commit}, selected) {
      commit('SORT_BY_DATE', selected);
      commit('CLEAR_PAGES');
    },
    async get_user_points({commit, rootGetters}) {
      const user = rootGetters['profile/user/user'];
      try {
        const user_points = await api.user.user_points(user.id);
        commit('SET_POINTS_HISTORY', user_points.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};

